import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import theme from 'src/theme';

export const SectionWrapper = styled(Box)`
    margin-top: 32px;
`;

export const SectionTitle = styled(Typography)`
    font-size: 16px;
    font-weight: 600;
    color: ${theme.color.white};
    margin-bottom: 16px;
`;

export const IterationGroup = styled(Box)`
    margin-bottom: 24px;
`;

export const IterationLabel = styled(Typography)`
    font-size: 13px;
    font-weight: 600;
    color: ${theme.color.white70};
    margin-bottom: 8px;
`;

export const TaskList = styled(Box)`
    background-color: ${theme.color.blackRock};
    border-radius: 4px;
    overflow: hidden;
`;

export const TaskRowItem = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    cursor: pointer;
    border-bottom: 1px solid ${theme.color.white07};
    &:last-child {
        border-bottom: none;
    }
    &:hover {
        background-color: ${theme.color.white07};
    }
`;

export const TaskRowTitle = styled(Typography)`
    font-size: 12px;
    color: ${theme.color.white80};
    font-family: Inter, sans-serif;
`;

export const TaskStatusPill = styled(Box)<{
    pillbg: string;
    pillcolor: string;
}>`
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 10px;
    font-size: 11px;
    font-family: Inter, sans-serif;
    white-space: nowrap;
    margin-left: 16px;
    background-color: ${({ pillbg }) => pillbg};
    color: ${({ pillcolor }) => pillcolor};
`;
